import React from "react";

export function CardOverlayLoader({...props}) {
    return (
        <>
            <div style={{position: "absolute", zIndex: 88, height:"100%", width: "100%", backgroundColor: "#f5f5f5b5"}} />
        </>
    )
}